export default __webpack_public_path__ + "static/media/search.ed25138b.gif";